import React from 'react'
import PopupContent from './PopupContent'

const Popup = ({displayPopup, addClassToBackdrop="", addClassToPopup, onClosePopup, children, translation}) => (
    displayPopup && <PopupContent
        children={children}
        addClassToBackdrop={addClassToBackdrop}
        addClassToPopup={addClassToPopup}
        translation={translation}
        onClosePopup={onClosePopup}
    />
)

export default Popup